<div class="keylesson-player-container">
  <h1 fxLayout="row" fxLayoutAlign="center center" class="dark-gray">
    {{ 'KEYLESSON.DETAIL.TITLE' | translate: {value: lesson.id} }}
  </h1>
  
  <!-- exercise selector -->
  <div class="exercises-carousel" fxLayout="row" fxLayoutAlign="center center">
    <i class="ri-arrow-left-s-line" (click)="exerciseChanged$.next('left')"></i>

    <h2>{{ 'KEYLESSON.PLAYER.EX.OF' | translate: {value: selectedExercise, totalValue: lesson.exercises.length} }}</h2>

    <i class="ri-arrow-right-s-line" (click)="exerciseChanged$.next('right')"></i>
  </div>

  <!-- keyboard -->
  <ng-content *ngTemplateOutlet="keyboard; context:{keyboardinuse: authService.user$.value.keyboard_in_use}"></ng-content>
  
  <div class="loadkeys-container">
    <div class="secondary-button">{{ 'KEYLESSON.PLAYER.LOAD.KEYS' | translate }}</div>
  </div>

  <!-- main container -->
  <div fxLayout="row" class="main-container">
    
    <!-- exercise -->
    <div fxFlex="70" fxLayout="column" class="exercise-container">

      <!-- form -->
      <div class="exercise-form">{{ exercise }}</div>

      <!-- user-input -->
      <div class="html-user-input">
        <ng-container *ngFor="let typedKey of state.typedKeys">
          <span [ngClass]="{'not-correct': !typedKey.isCorrect}">{{ typedKey.key }}</span>
        </ng-container>
        
      </div>

      <h3 align="center" *ngIf="state.nextKey">{{ state.nextKey.character !== 'space' ? getCaseNextKey() + state.nextKey.finger : state.nextKey.finger }}</h3>

      <!-- resume -->
      <div fxFlex="row" fxLayoutAlign="space-between center" class="footer-resume">

        <div class="buttons-control light-blue">
          <span (click)="finishGame()"><i class="icon-md ri-stop-circle-line"></i>&nbsp;{{ 'KEYLESSON.PLAYER.STOP' | translate }}</span>
          <span (click)="resetUserInput()"><i class="icon-md ri-history-line"></i>&nbsp;{{ 'KEYLESSON.PLAYER.RESTART' | translate }}</span>
        </div>

        <div class="results">
          <span>{{ 'KEYLESSON.PLAYER.KEYSTROKES' | translate }}:&nbsp;<strong>{{state.totalStrokes + state.strokes}}</strong></span>
          <span>{{ 'KEYLESSON.PLAYER.ERRORS' | translate }}:&nbsp;<strong>{{state.totalErrors + state.errors}}</strong></span>
        </div>

      </div>

    </div>

    <!-- video -->
    <div fxFlex="30">
      <video #videoPlayer class="video" controls autoplay *ngIf="!!exerciseVideoUrl">
        <source [src]="exerciseVideoUrl" type="video/mp4">
        Your browser does not support the video tag.
      </video>         
    </div>

  </div>



  <input #charInput id="user-input" type="text" [formControl]="userInput" autocomplete="off">

  <!-- dev -->
  <ng-container *ngIf="false">
    <!-- keyboard -->
    <div class="keyboard">
      <div 
        class="key" 
        *ngFor="let key of allowedKeys"
        [ngStyle]="{
          'left.px': key.x,
          'top.px': key.y,
          'color': key.color.replace('0x', '#')
        }">
        {{key.character}}
      </div>
    </div>

    <!-- exercise -->
    <div class="exercise">
      {{ exercise }}
    </div>

    <!-- user input -->
    <div class="user-input">
      <input #charInput id="user-input" type="text" [formControl]="userInput" autocomplete="off">
    </div>

    <div class="html-user-input">
      <span *ngFor="let typedKey of state.typedKeys" [ngClass]="{'not-correct': !typedKey.isCorrect}">{{ typedKey.key }}</span>
    </div>

    <div class="next-key" *ngIf="state.nextKey">{{ state.nextKey.character + state.nextKey.finger }}</div>

    <div class="timer">{{ state.timeSpent }}</div>

    <pre>{{ state | json }}</pre>
  </ng-container>

  <!-- set new bookmark -->
  <div class="bookmark">
    <span class="light-blue" (click)="setNewBookmark()"><i class="icon-lg light-blue ri-star-line"></i>&nbsp;{{ 'KEYLESSON.PLAYER.SET.BOOKMARK' | translate }}</span>
    <span class="message-success" *ngIf="showBookmarkMsg">{{ 'KEYLESSON.PLAYER.BOOKMARK.ADDED' | translate }}</span>
  </div>

</div>


<!-- keyboards template -->
<ng-template #keyboard let-keyboardinuse="keyboardinuse">
  <ng-container [ngSwitch]="keyboardinuse">
    <!-- keyboard 1 -->
    <ng-container *ngSwitchCase="'1'">
      <div class="keyboard" style="background-image: url('assets/images/keyboards/playables/key1.png');height:330px; background-size: cover;zoom: 0.7;margin: 0 auto;width: 880px;">
        <div 
          class="key" 
          *ngFor="let key of allowedKeys"
          [ngStyle]="{
            'left.px': key.x,
            'top.px': key.y,
            'color': key.color.replace('0x', '#'),
            'width.px': 70,
            'height.px': 40
          }"      
          [ngClass]="{'animate-flicker': isNextKey(key)}">
          {{key.character}}
        </div>
      </div>
    </ng-container>

    <!-- keyboard 2 -->
    <ng-container *ngSwitchCase="'2'">
      <div class="keyboard" align="center" style="background-image: url('assets/images/keyboards/playables/key2.png');height:340px; background-size: cover;zoom: 0.7;margin: 0 auto;width: 780px;">
        
        <div 
          class="key" 
          *ngFor="let key of allowedKeys"
          [ngStyle]="{
            'left.px': key.x,
            'top.px': key.y,
            'color': key.color.replace('0x', '#'),
            'width.px': 120,
            'height.px': 30,
            'font-size.px':18
          }"      
          [ngClass]="{'animate-flicker': isNextKey(key)}">
          {{key.character}}
        </div>
      </div>
    </ng-container>

    <!-- keyboard 3 -->
    <ng-container *ngSwitchCase="'3'">      
      <div class="keyboard" style="background-image: url('assets/images/keyboards/playables/key3.png');background-size: contain;height: 380px; width: 860px;zoom: 0.7;margin: 0 auto;">
        <div 
          class="key" 
          *ngFor="let key of allowedKeys"
          [ngStyle]="{
            'left.px': key.x,
            'top.px': key.y,
            'color': key.color.replace('0x', '#'),
            'width.px': 60,
            'height.px': 46
          }"      
          [ngClass]="{'animate-flicker': isNextKey(key)}">
          {{key.character}}
        </div>
      </div>  
    </ng-container>

    <!-- keyboard 4 -->
    <ng-container *ngSwitchCase="'4'">
      <div class="keyboard" style="background-image: url('assets/images/keyboards/playables/key4.png');height:330px; background-size: contain;zoom: 0.7;margin: 0 auto;width: 840px;">
        <div 
          class="key" 
          *ngFor="let key of allowedKeys"
          [ngStyle]="{
            'left.px': key.x,
            'top.px': key.y,
            'color': key.color.replace('0x', '#'),
            'width.px': 10,
            'height.px': 27
          }"      
          [ngClass]="{'animate-flicker': isNextKey(key)}">
          {{key.character}}
        </div>
      </div>
    </ng-container>

    <!-- keyboard 5 -->
    <ng-container *ngSwitchCase="'5'">
      <div class="keyboard" align="center" style="height: 340px;zoom: 0.7;margin: 0 auto;margin-left: 15%;">
        <img width="891px" style="position: absolute;left:14px;top:1px; transform: rotate(2deg);" src="assets/images/keyboards/playables/key5.png">
        <div 
          class="key" 
          *ngFor="let key of allowedKeys"
          [ngStyle]="{
            'left.px': key.x,
            'top.px': key.y,
            'color': key.color.replace('0x', '#'),
            'width.px': 85,
            'height.px': 49,
            'font-size.px': 20
          }"      
          [ngClass]="{'animate-flicker': isNextKey(key)}">
          {{key.character}}
        </div>
      </div>
    </ng-container>

  </ng-container>


</ng-template>